import React, { useState } from 'react';

import { FormattedMessage } from '../../../../util/reactIntl';

import css from './Faq.module.css';

const questions = [
  {
    id: 'cost',
    questionId: 'ForProvidersFaq.costQuestion',
    question: "What's the cost to providers?",
    answerId: 'ForProvidersFaq.costAnswer',
    answer:
      "There's no upfront fee to join. PostPartners only earns a commission when you're booked through the platform, and fees vary depending on the services you offer.",
  },
  {
    id: 'payment',
    questionId: 'ForProvidersFaq.paymentQuestion',
    question: 'How do I receive payment?',
    answerId: 'ForProvidersFaq.paymentAnswer',
    answer:
      "Families pay through PostPartners when they book, and you're paid directly to your bank account through Stripe.",
  },
  {
    id: 'timing',
    questionId: 'ForProvidersFaq.timingQuestion',
    question: 'How long does it take for my application to be accepted?',
    answerId: 'ForProvidersFaq.timingAnswer',
    answer:
      "Most applications are reviewed within 1 day. We'll email you as soon as you're approved.",
  },
  {
    id: 'insurance',
    questionId: 'ForProvidersFaq.insuranceQuestion',
    question: 'Can I accept insurance through the platform?',
    answerId: 'ForProvidersFaq.insuranceAnswer',
    answer: 'Not right now. Families pay directly through PostPartners.',
  },
  {
    id: 'location',
    questionId: 'ForProvidersFaq.locationQuestion',
    question: 'What locations does PostPartners serve?',
    answerId: 'ForProvidersFaq.locationAnswer',
    answer:
      "We serve families across New York City and the tri-state area. Virtual providers can support families wherever they're licensed or qualified to practice.",
  },
  {
    id: 'virtual',
    questionId: 'ForProvidersFaq.virtualQuestion',
    question: 'Can I provide virtual care?',
    answerId: 'ForProvidersFaq.virtualAnswer',
    answer:
      'Yes. You can offer in-home, in-office, or virtual care, or any mix. Your listing will show what you offer, so families can choose what works best for them.',
  },
  {
    id: 'background',
    questionId: 'ForProvidersFaq.backgroundQuestion',
    question: 'How are background checks performed?',
    answerId: 'ForProvidersFaq.backgroundAnswer',
    answer:
      "We use Checkr, a trusted background check service. Once you apply, you'll get a secure link to give consent and enter your details. We'll let you know as soon as it's complete.",
  },
];

/**
 * Provider questions shown before the closing call to action.
 */
const Faq = () => {
  const [openId, setOpenId] = useState(null);

  return (
    <section className={css.root}>
      <div className={css.inner}>
        <div className={css.copy}>
          <p className={css.eyebrow}>
            <FormattedMessage id="ForProvidersFaq.eyebrow" defaultMessage="Provider questions" />
          </p>
          <h2 className={css.title}>
            <FormattedMessage
              id="ForProvidersFaq.title"
              defaultMessage="A few things worth knowing"
            />
          </h2>
        </div>
        <ul className={css.list}>
          {questions.map(item => {
            const open = openId === item.id;
            return (
              <li key={item.id} className={css.item}>
                <button
                  className={css.question}
                  type="button"
                  aria-expanded={open}
                  onClick={() => setOpenId(open ? null : item.id)}
                >
                  <FormattedMessage id={item.questionId} defaultMessage={item.question} />
                  <span className={css.icon} aria-hidden="true">
                    {open ? '−' : '+'}
                  </span>
                </button>
                {open ? (
                  <p className={css.answer}>
                    <FormattedMessage id={item.answerId} defaultMessage={item.answer} />
                  </p>
                ) : null}
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default Faq;
